import Divider from '@mui/material/Divider';

const PyDivider = () => {
  return <Divider sx={{ margin: '0 5px', height: 23, alignSelf: 'center' }} orientation="vertical" variant="middle" flexItem />;
};

export default PyDivider;
